module.exports = __webpack_public_path__ + "static/twitter_port-57f54f406e738814120aff2955e79330.png";